/** Public build-time contacts. Provider delivery configuration stays server-side. */
export function salesMailto(subject: string): string {
  const email = import.meta.env.VITE_LEADCAT_SALES_EMAIL?.trim() || "director@staminal.in";
  return `mailto:${encodeURIComponent(email).replace(/%40/g, "@").replace(/%2B/g, "+")}?subject=${encodeURIComponent(subject)}`;
}
